import { ActionButtonProps, Box, BoxProps, ColorOptions, Form, Icon, Spacer } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { FC, useState } from 'react'
import { ModalAlertView } from '../../components/ModalAlertView'
import { useStores } from '../../data/store'
import { formData } from './formData'

interface Props {
  id: any
  onUpdate?: any
  isEditable: boolean
  isDeletable: boolean
  onClose?: () => void
}

const FormBox = ({ children }: any) => {
  return <Box {...styles.formContainer}>{children}</Box>
}

const AddNewMappingForm: FC<Props> = (props: Props) => {
  const { id, isEditable, isDeletable } = props

  const [toggle, setToggle] = useState(false)

  const { merchantData, message } = useStores((store) => ({
    merchantData: store.ledgerMapping.getMerchant,
    message: store.message.getFormMessage(),
  }))

  const handleActions = ({ values, title, defaultActionButtonOnSubmit, resetForm, isValid }: ActionButtonProps) => {
    const handleOnPress = () => {
      defaultActionButtonOnSubmit()
    }

    return (
      <Box pv={16} flexDirection="row" align={'center'} justify={'center'}>
        <ModalAlertView
          onPress={() => {}}
          show={toggle}
          onDismiss={() => setToggle(false)}
          title="Delete Merchant Mapping"
          buttonTitle="Delete"
          message={`Is this final. This will delete mapping with ID ${id}.`}
        />
        {isEditable && (
          <ButtonNew
            title={id ? 'Update' : title}
            onPress={handleOnPress}
            height={40}
            color={'#214796'}
            titleColor={'WHITE'}
            textType={'body14'}
            width={280}
          />
        )}
        <Spacer direction="horizontal" size={16} />
        {isDeletable && id && (
          <Box
            onPress={() => {}}
            bg="RED"
            underlayColor="ERROR"
            p={'MEDIUM'}
            justify={'center'}
            align={'center'}
            borderRadius={4}>
            <Icon id="DELETE" size={24} color="WHITE" />
          </Box>
        )}
      </Box>
    )
  }

  return (
    <Box>
      <Form
        initialValues={id ? merchantData(true) : {}}
        formData={formData(id, isEditable)}
        actionButtons={handleActions}
        container={FormBox}
      />
    </Box>
  )
}

export { AddNewMappingForm }

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}

const styles = {
  formContainer: {
    underlayColor: 'WHITE',
    bg: 'WHITE',
    padding: 'MEDIUM',
    backgroundColor: 'WHITE',
    minWidth: 300,
    borderWidth: 1,
    borderTopWidth: 0,
    borderColor: '#e3e6f0' as ColorOptions,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    ...shadow,
  } as BoxProps,
}
